"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationStatus = void 0;
var TranslationStatus;
(function (TranslationStatus) {
    TranslationStatus["CANCELLED"] = "CANCELLED";
    TranslationStatus["QUEUED"] = "QUEUED";
    TranslationStatus["PROCESSING"] = "PROCESSING";
    TranslationStatus["COMPLETED"] = "COMPLETED";
})(TranslationStatus = exports.TranslationStatus || (exports.TranslationStatus = {}));
